import React from "react";
import { tokens } from "@/lib/theme";

export default function DemoBadge({ theme = "light", lang = "fr" }) {
  const T = tokens(theme);
  const label = lang === "fr" ? "⚠ Profil démo" : "⚠ Demo profile";
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 4,
      padding: "3px 8px", borderRadius: 999, fontSize: 10, fontWeight: 700,
      backgroundColor: T.amberSoft, color: T.amber,
      fontFamily: "ui-monospace, Menlo, monospace",
      letterSpacing: "0.08em", textTransform: "uppercase",
      border: `1px solid ${T.amber}`
    }}>
      {label}
    </span>
  );
}
